import * as EmailValidator from 'email-validator'
import type {CountryCode as PhoneCountryCode} from 'libphonenumber-js'
import {parsePhoneNumberFromString} from 'libphonenumber-js'

import type {Validator} from './interfaces'

const isRequired: Validator = (state, key) => {
    const value = state[key]

    if (typeof value === 'boolean') {
        return value
    }

    if (value instanceof File) {
        return value.name !== ''
    }

    return value.trim() !== ''
}

export const parsePhoneNumber = (phoneNumber: string, countryCode: PhoneCountryCode) =>
    parsePhoneNumberFromString(phoneNumber, countryCode)

const isValidPhoneNumber: Validator = (state, key) => {
    const phoneNumber = state[`${key}-phoneNumber`]
    const countryCode = state[`${key}-countryCode`]

    const parsedPhoneNumber = parsePhoneNumber(
        phoneNumber as string,
        countryCode as PhoneCountryCode
    )

    // Checks only for phoneNumber as countryCode is prefilled and can never be undefined
    return isRequired(state, `${key}-phoneNumber`) && !!parsedPhoneNumber?.isValid()
}

const isValidEmail: Validator = (state, key) => {
    const value = state[key]

    return typeof value === 'string' && EmailValidator.validate(value)
}

export const validators = {isRequired, isValidPhoneNumber, isValidEmail}
